export const ISSUE_TYPE = [
    {
        label: 'Lỗi may/Gia công',
        value: 'Lỗi may/Gia công'
    },
    {
        label: 'Sai hàng',
        value: 'Sai hàng'
    },
    {
        label: 'Size chart',
        value: 'Size chart'
    },
    {
        label: 'Thiếu hàng',
        value: 'Thiếu hàng'
    },
    {
        label: 'Sản phẩm lỗi',
        value: 'Sản phẩm lỗi'
    },
    {
        label: 'Vùng in to bé - lệch vùng in',
        value: 'Vùng in to bé - lệch vùng in'
    },
    {
        label: 'Hình in mờ',
        value: 'Hình in mờ'
    },
    {
        label: 'Lệch màu in',
        value: 'Lệch màu in'
    },
    {
        label: 'Lỗi design',
        value: 'Lỗi design'
    },
    {
        label: 'Lỗi vải/Phôi/NVL',
        value: 'Lỗi vải/Phôi/NVL'
    },
    {
        label: 'Damage (gãy, vỡ, hỏng)',
        value: 'Damage (gãy, vỡ, hỏng)'
    },
    {
        label: 'Delay',
        value: 'Delay'
    },
    {
        label: 'Lost',
        value: 'Lost'
    },
    {
        label: 'Khác',
        value: 'Khác'
    },
]

export const SOLUTION = [
    {
        label: 'Refund',
        value: 'refund'
    },
    {
        label: 'Replace',
        value: 'replace'
    },
]

export const CONFIRMED = [
    {
        label: 'Yes',
        value: 'yes'
    },
    {
        label: 'No',
        value: 'no'
    },
]

export const STATUS = [
    {
        label: 'Checking',
        value: 'checking'
    },
    {
        label: 'Confirmed',
        value: 'confirmed'
    },
    {
        label: 'Quá hạn duyệt',
        value: 'confirmation_overdue'
    },
    // {
    //     label: 'Done',
    //     value: 'done'
    // },
    {
        label: 'Khác',
        value: 'approved'
    },
]

export const SUPPLIER_CONFIRM = [
    {
        label: 'Approve',
        value: 'approve'
    },
    {
        label: '50/50',
        value: 'half'
    },
    {
        label: 'Reject',
        value: 'reject'
    },
]

// @FAC-25799 — công đoạn lỗi xưởng chọn khi duyệt. `value` PHẢI khớp ERROR_STAGES ở
// supplier-management-service (nơi lưu + validate) và PRODUCTION_STAGES ở exporter-service (popup).
export const ERROR_STAGES = [
    {label: 'In', value: 'printed'},
    {label: 'Cắt', value: 'cut'},
    {label: 'Khắc', value: 'engraved'},
    {label: 'Hoàn thiện', value: 'improved'},
    {label: 'QC hoàn thành', value: 'qc_completed'},
    {label: 'Đóng gói', value: 'packing'},
    {label: 'Dán label', value: 'labelled'},
    {label: 'Đóng thùng', value: 'packaged'},
    {label: 'Chưa xác định', value: 'unknown'},
]
